import { render, staticRenderFns } from "./PayrollPPL.vue?vue&type=template&id=52ecc349"
import script from "./PayrollPPL.vue?vue&type=script&lang=js"
export * from "./PayrollPPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports